import Vue from "vue"
import { firestorePlugin } from "vuefire"

Vue.use(firestorePlugin)

import Firebase from "firebase/app"
import "firebase/firestore"

const firebaseConfig = {
  apiKey: "AIzaSyBB3dY_mhCH-PAsAhpM75UiwJYAyuFJgAQ",
  authDomain: "nanocom.firebaseapp.com",
  databaseURL: "https://nanocom.firebaseio.com",
  projectId: "nanocom",
  storageBucket: "nanocom.appspot.com",
  messagingSenderId: "536130237347",
  appId: "1:536130237347:web:d189879a2a5a059d6a2016"
}

Firebase.initializeApp(firebaseConfig)

export const firebase = Firebase